<template>
  <l-modal
    :showing="showing"
    text="Assessment Remimes"
    icon="edit"
    color="bg-orange-500"
    @close="close"
  >
    <div class="w-full text-xs" v-if="editObj.id">
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Id</b>
          <br />
          <l-input
            placeholder="Enter unique Id"
            v-model="editObj.id"
            inputClass="text-2xs"
            :disabled="!this.isnew"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Name</b>
          <br />
          <l-input
            placeholder=""
            v-model="editObj.name"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Zone</b>
          <br />
          <l-select
            v-model="editObj.zoneid"
            class="text-xs"
            :data="zones"
            :multiple="false"
          >
            <l-option
              v-for="i in zones"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Pollutants</b>
          <br />
          <l-select
            v-model="editObj.pollutant"
            class="text-xs"
            :data="pollutants"
            :multiple="false" @change="updateAssessmentData"
          >
            <l-option
              v-for="i in pollutants"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Assessment Threshold Exceedance</b>
          <br />
          <l-select
            v-model="editObj.assessmentthresholdexceedance"
            class="text-xs"
            :data="assessmentthresholdexceedances"
            :multiple="false"
          >
            <l-option
              v-for="i in assessmentthresholdexceedances"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>      
        </div>
        <div class="w-1/2">
          <b>Object Type</b>
          <br />
          <l-select
            v-model="editObj.objecttype"
            class="text-xs"
            :data="objecttypes"
            :multiple="false"
          >
            <l-option
              v-for="i in objecttypes"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Reporting Metric</b>
          <br />
          <l-select
            v-model="editObj.reportingmetric"
            class="text-xs"
            :data="reportingmetrics"
            :multiple="false"
          >
            <l-option
              v-for="i in reportingmetrics"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
        <div class="w-1/2">
          <b>Protection Target</b>
          <br />
          <l-select
            v-model="editObj.protectiontarget"
            class="text-xs"
            :data="protectiontargets"
            :multiple="false"
          >
            <l-option
              v-for="i in protectiontargets"
              :key="i.value"
              class="text-xs"
              :value="i.value"
              :label="i.label"
            />
          </l-select>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
          <b>Threshold Classification Year</b>
          <br />
          <l-input
            placeholder="Enter 'Threshold Classification Year'"
            v-model="editObj.thresholdclassificationyear"
            inputClass="text-2xs"
          ></l-input>
        </div>
        <div class="w-1/2">
          <b>Threshold Classification Report</b>
          <br />
          <l-input
            placeholder="Enter 'Threshold Classification Report'"
            v-model="editObj.thresholdclassificationreport"
            inputClass="text-2xs"
          ></l-input>
        </div>
      </div>
      <div class="w-full flex mb-4">
        <div class="w-1/2 mr-2">
           <b>Include</b>
          <input v-model="editObj.include" type="checkbox" class="bigCheckbox" />     
        </div>
        <div class="w-1/2">

        </div>
      </div>     

      <div class="w-full flex mb-4">
        <div class="w-full">
          <b>Available Sampling Points</b>
          <span style="display:none">{{pollutant}} </span>
          <br />
          <div class="checkboxList" >
            <div v-for='ad in this.assessementDataBox' :key='ad.assessmentlocal_id' class="flex" >
              <div class="w-1/2">
                <label >
                  <input v-model="ad.selected" type="checkbox" :id="ad.assessmentlocal_id" />
                  {{ ad.station_name }} <span class='ls'> {{"("+ ad.assessmentlocal_id+")"}}</span>
                </label>
              </div>
              <div class="w-1/4 mr-2">
                <l-select
                  v-model="ad.assessmenttype"
                  class="text-xs"
                  :data="assessmenttypes"
                  :multiple="false"
                >
                  <l-option
                    v-for="i in assessmenttypes"
                    :key="i.value"
                    class="text-xs"
                    :value="i.value"
                    :label="i.label"
                  />
                </l-select>
              </div>
              <div class="w-1/4 ">
                <l-input
                  placeholder="Enter 'Assessment Methodede Description'"
                  v-model="ad.assessmentmethodedescription"
                  inputClass="text-2xs"
                ></l-input>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex w-full justify-between">
        <l-button type="success" @click="onSave">Save changes</l-button>
        <l-button type="danger" @click="close">Cancel</l-button>
      </div>
    </div>
  </l-modal>
</template>

<script>
import LModal from "@/components/LModal";
import { LInput, LButton, LSelect, LOption } from "@/components/forms";
import AssessmentRegimesService from "./assessmentRegimes.service";

export default {
  name: "LLEdit",
  props: [
    "showing",
    "assessmentRegimes",
    "zones",
    "pollutants",
    "assessmenttypes",
    "objecttypes",
    "reportingmetrics",
    "protectiontargets",
    "assessmentthresholdexceedances",
    "assessmentdataAll",
    "selected",
    "isnew"
  ],
  components: {
    LModal,
    LInput,
    LButton,
    LSelect,
    LOption
  },
    data() {
      return {
        pollutantId: '0',
        assessmentdata: []
    };
  },
  computed: {
    editObj: function() {
      return Object.assign({}, this.selected);
    },
    pollutant:  function(){

      if (this.showing == true)
      if(!!this.editObj.pollutant) {
        this.pollutantId = this.editObj.pollutant.substr(this.editObj.pollutant.lastIndexOf('/')+1);
        return this.pollutantId;
      } else return null;
    },
    assessementDataBox: function(){ 
        if (!this.assessmentdataAll) return null;
        let pollutant_id = this.pollutantId;
        this.assessmentdata =  this.assessmentdataAll.filter(function(ad) {
            return ad.pollutant_id == pollutant_id;
          });
        let id = this.editObj.id
        this.assessmentdata.forEach(function(part, index) {
          !!this[index].id && this[index].assessmentregime_id == id ?  this[index].selected = true : false;
        }, this.assessmentdata); 
        return this.assessmentdata;
    },
    componentUsed: function() {
       return new Set(this.assessmentdataAll.map(x=>x.pollutant_name));
    },
  },
  methods: {
    updateAssessmentData() {
      this.pollutantId = this.editObj.pollutant.substr(this.editObj.pollutant.lastIndexOf('/')+1);

        },
    close() {
      this.$emit("close");
    },
    onSave() {
      this.editObj.include = this.editObj.include ? '1' : '0';

      let dataUpdate =  this.assessmentdata.filter(function(ad) {
            return ad.selected;
          });
      let id = this.editObj.id;
      dataUpdate.forEach(function(part, index) {
        this[index].assessmentregime_id = id;
      }, dataUpdate); 


      let dataDelete =  this.assessmentdata.filter(function(ad) {
            return !ad.selected && !!ad.assessmentregime_id;
          }).map(x=>x.id);
      debugger
      this.$emit("save", {regime: this.editObj, dataUpdate: dataUpdate, dataDelete: dataDelete});
      this.close();
    }
  }
}
</script>
<style lang="postcss">
.bigCheckbox {
    width: 70px;
    height: 16px;
    margin-top: 6px;
}
.checkboxList {
  overflow-y: scroll; padding: 10px; border-color: #a0aec0; border-radius: 0.25rem; border-width: 1px; height: 172px;
}
 .checkboxList div label{
  vertical-align: -webkit-baseline-middle;
} 
span.ls {
  letter-spacing: -1px;
  padding-left: 0;
}

</style>